module.exports = __webpack_public_path__ + "img/DpsIcon.d658da8d.png";